import React, { Component } from "react"
import { Form } from "app/forms/form"
import * as Elements from "app/forms/elements"

import thumbnail from "app/forms/images/templates/rainier.jpg"

class Rainier extends Component {
  static displayName = "Rainier"
  static style = "form"
  static formats = ["inline", "modal", "slide in"]
  static thumbnail = thumbnail
  static fields = [
    {
      name: "email_address",
      label: "Your email address"
    }
  ]

  render() {
    const { styles, elements, ...props } = this.props
    const customFieldCount = elements.custom.length
    const stackedDisplay = customFieldCount > 0
    const background_color = styles.forElement("background").backgroundColor

    return (
      <Form {...props} style={styles.forElement("form", {})}>
        <div
          className="formkit-container"
          style={styles.forElement("container")}
          data-style="full"
        >
          <div className="formkit-hero">
            <div
              className="formkit-hero-bg-color"
              style={{ backgroundColor: background_color }}
            />
            <div
              className="formkit-hero-bg-img"
              style={styles.forElement("background")}
            />
            <Elements.Content
              name="header"
              defaults={{
                content: "Join our newsletter"
              }}
            />
            <Elements.Content
              name="content"
              defaults={{
                content: "Receive tips and tricks on how to lorum ipsum."
              }}
            />
          </div>
          <div>
            <Elements.Errors />

            <Elements.CustomFields
              direction={stackedDisplay ? "vertical" : "horizontal"}
              data-stacked={stackedDisplay}
            >
              {stackedDisplay && <Elements.AddFieldButton />}
              <Elements.Button
                name="submit"
                group="button"
                defaults={{ content: "Send it my way!" }}
              />
            </Elements.CustomFields>

            {!stackedDisplay && <Elements.AddFieldButton />}

            <Elements.BuiltWith background="container" />
          </div>
        </div>
      </Form>
    )
  }
}

Rainier.displayName = "Rainier"

export default Rainier
